import { Injectable } from '@angular/core';
import { FeUtil } from '../../../hezky-routes';
import { Observable } from 'rxjs';
import { SCHEDULER } from '../hezky-fe-services/api.service';


@Injectable({
  providedIn: 'root'
})
export class SchedulerService {

  constructor(private readonly feUtil: FeUtil) { }

  generateScheduleReport(payload: any): Observable<any> {
    return this.feUtil.httpSvc.post(SCHEDULER.ADD_REPORT, payload)
  }

  deleteScheduleReport(payload: any): Observable<any> {
    return this.feUtil.httpSvc.delete(SCHEDULER.DELETE_REPORT(payload.report_name))
  } 
}
